const bigInt = require('big-integer');

const alphabet5Bit = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567';
const alphabet6Bit = ' ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

function checkHex(n) {
  return /^[0-9A-Fa-f]*$/.test(n);
}

function checkBit(n) {
  return /^[01]*$/.test(n);
}
function checkDec(n) {
  return /^[0-9]*$/.test(n);
}

function hexStringToBitString(hex) {
  if (!checkHex(hex)) {
    return '';
  }
  let bits = '';
  for (let index = 0; index < hex.length; index++) {
    let word = parseInt(hex[index], 16).toString(2);
    bits += word.padStart(4, '0');
  }
  return bits;
}

function bitStringToHexString(bits) {
  if (!checkBit(bits)) {
    return 'X';
  }
  while (bits.endsWith('0000')) {
    bits = bits.substring(0, bits.length - 4);
  }
  //do actual conversion
  let hex = '';
  for (let i = 0; i < bits.length / 4; i++) {
    let word;
    if (bits.length >= i * 4 + 4) {
      word = bits.substring(i * 4, i * 4 + 4);
    } else {
      word = (bits.substring(i * 4) + '0000').substring(0, 4);
    }
    hex += parseInt(word, 2).toString(16);
  }
  return hex.toUpperCase();
}

function decStringToBitString(dec, length = 0) {
  dec = bigInt(dec);
  if (!checkDec(dec) || dec < 0) {
    return '';
  }
  return dec.toString(2).padStart(length, '0');
}

function bitStringToDecString(n) {
  if (!checkBit(n)) {
    return '';
  }
  return bigInt(n, 2).toString(10);
}

function bitStringTo7bitAscii67String(bits) {
  if (!checkBit(bits)) {
    return '';
  }
  while (bits.endsWith('0000000')) {
    bits = bits.substring(0, bits.length - 7);
  }
  let ascii = '';
  //do actual conversion
  for (let i = 0; i < bits.length / 7; i++) {
    let word;
    if (bits.length >= i * 7 + 7) {
      word = bits.substring(i * 7, i * 7 + 7);
    } else {
      word = (bits.substring(i * 7) + '0000000').substring(0, 7);
    }
    const index = parseInt(word, 2);
    if (index !== 0) {
      ascii += String.fromCharCode(index);
    }
  }
  return ascii;
}
function ascii67To7BitString(ascii, length) {
  let bits = '';
  for (let index = 0; index < ascii.length; index++) {
    let word = ascii[index].charCodeAt(0).toString(2);
    bits += word.padStart(7, '0');
  }
  if (!length) {
    return bits;
  }
  return (bits + Array(length + 1).join('0')).substring(0, length);
}

function bitStringTo5bitAlphabetString(bits) {
  const charBitLength = 5;
  let result = '';
  const alphabet = alphabet5Bit;
  for (let i = 0; i <= bits.length; i = i + charBitLength) {
    let t = '';
    if (bits.length >= i + charBitLength) {
      t = bits.substring(i, i + charBitLength);
    } else {
      t = (bits.substring(i) + '00000').substring(0, charBitLength);
    }
    const index = parseInt(t, 2);
    if (index !== 0) {
      if (index <= alphabet.length) {
        result += alphabet[index];
      } else {
        result += '□';
      }
    }
  }
  return result;
}
function alphabetStringTo5BitString(input) {
  input = input.toUpperCase();
  const charBitLength = 5;
  let result = '';
  const alphabet = alphabet5Bit;
  for (let i = 0; i < input.length; i++) {
    const element = input[i];
    const index = alphabet.indexOf(element);
    if (index == -1) {
      result += '11111';
    } else {
      result += decStringToBitString(index, charBitLength);
    }
  }
  return result;
}

function bitStringTo6bitAlphaNumericString(bits) {
  const charBitLength = 6;
  let result = '';
  //NOTE: In the URL and Filename safe variant, character 62 is replaced with a "-" (minus sign) and character 63 is replaced with a "_" (underscore).
  const alphabet = alphabet6Bit;
  for (let i = 0; i < bits.length; i += charBitLength) {
    let t = '';
    if (bits.length >= i + charBitLength) {
      t = bits.substring(i, i + charBitLength);
    } else {
      t = (bits.substring(i) + '000000').substring(0, charBitLength);
    }
    const index = parseInt(t, 2);
    if (index !== 0) {
      if (index < alphabet.length) {
        result += alphabet[index];
      } else {
        result += '□';
      }
    }
  }
  return result;
}
function alphaNumericTo6BitString(input) {
  const charBitLength = 6;
  let result = '';
  const alphabet = alphabet6Bit;
  for (let i = 0; i < input.length; i++) {
    const element = input[i];
    const index = alphabet.indexOf(element);
    if (index == -1) {
      result += '111111';
    } else {
      result += decStringToBitString(index, charBitLength);
    }
  }
  return result;
}

module.exports = {
  hexStringToBitString,
  bitStringToHexString,
  decStringToBitString,
  bitStringToDecString,
  alphabetStringTo5BitString,
  bitStringTo5bitAlphabetString,
  alphaNumericTo6BitString,
  bitStringTo6bitAlphaNumericString,
  ascii67To7BitString,
  bitStringTo7bitAscii67String,
};
